export const GENERIC_ERROR_TITLE = "Oooops! Something went wrong";
export const GENERIC_ERROR_SUBTITLE = "Please try to reload the page";
export const GENERIC_ERROR_SUBTITLE_MOBILE = "Please try to reload the app";

export const UNAUTHORIZED_ERROR_TITLE = "Oooops! Something went wrong";
export const UNAUTHORIZED_ERROR_SUBTITLE =
  "The page is missing or you don't have the required permissions to view it";
export const UNAUTHORIZED_ERROR_BUTTON_TEXT = "Go back";

export const FORBIDDEN_ERROR_TITLE = "Page not available";
export const FORBIDDEN_ERROR_SUBTITLE_FIRST_LINE =
  "Seems like you have insufficient privileges to view data.";
export const FORBIDDEN_ERROR_SUBTITLE_SECOND_LINE =
  "Please contact support if you need to get access.";
export const FORBIDDEN_ERROR_BUTTON_TEXT = "Go back";

export const REQUEST_TIMEOUT_ERROR_TITLE = "Request Timeout";
export const REQUEST_TIMEOUT_ERROR_SUBTITLE =
  "Please try again with more specific request for the best match";

export const INTERNAL_SERVER_ERROR_TITLE = "Oooops! Something went wrong";
export const INTERNAL_SERVER_ERROR_SUBTITLE = "Please try to reload the page";
export const INTERNAL_SERVER_ERROR_SUBTITLE_MOBILE =
  "Please try to reload the app";
